
const BASE_URL_ENV = {
  TESING: 'http://127.0.0.1:8203/znrunpay',
  PRODUCTION: 'https://manager.paynow.life/znrunpay/',
  DEVELOPMENT: 'http://127.0.0.1:8203/znrunpay',
}

/** 文档落盘目录（运维/本地约定；浏览器无法直接写入，需导出后手动或脚本同步） */
const XPAYDOC_DOCUMENT_FS_PATH_ENV = {
  TESING: "/Users/mark/Downloads",
  DEVELOPMENT: "/Users/mark/Downloads",
  PRODUCTION: "/www/wwwroot/xpaydoc",
} as const;

const { REACT_APP_RUNTINE_ENV: REACT_ENV } = process.env;
const RUNTIME_ENV = REACT_ENV && REACT_ENV !== ""
  ? REACT_ENV
  : (process.env.NODE_ENV as string).toLocaleUpperCase();

const SAME_ORIGIN_API_HOSTS = new Set([
  "xflypay.com",
  "www.xflypay.com",
  "manager.paynow.life",
  "test.paynow.life",
  "manager.znrun.com",
]);

/**
 * 这些站点 nginx 已反代 /znrunpay。必须走当前域名，
 * 不能再打另一个 Cloudflare 站点（VPN 下跨 zone 的 XHR 会被拦/404）。
 */
const resolveBaseUrl = () => {
  if (typeof window !== "undefined" && SAME_ORIGIN_API_HOSTS.has(window.location.hostname)) {
    return `${window.location.origin}/znrunpay/`;
  }
  return BASE_URL_ENV[RUNTIME_ENV as keyof typeof BASE_URL_ENV];
};

export const BASE_URL = resolveBaseUrl()

export const APP_KEY = '71632d6c6d63616e672d3031313932303430';

/** 可通过 REACT_APP_XPAYDOC_FS_PATH 覆盖默认路径 */
export const XPAYDOC_DOCUMENT_FS_PATH =
  (process.env.REACT_APP_XPAYDOC_FS_PATH || "").trim() ||
  XPAYDOC_DOCUMENT_FS_PATH_ENV[RUNTIME_ENV as keyof typeof XPAYDOC_DOCUMENT_FS_PATH_ENV] ||
  XPAYDOC_DOCUMENT_FS_PATH_ENV.DEVELOPMENT;






